import http from 'http'
import filter from 'src/utils/filter'
import server from 'src/utils/server'

export const getUser = (id) => {
  return http.get(server.url_to_user(id))
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const updateSeller = (params) => {
  return http.put(server.url_to_me(), params)
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const validateUsername = (username) => {
  return http.get(server.url_to('sellers/available?') + filter.toQuery({ username: username }))
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}



// WEBPACK FOOTER //
// ./src/app/pages/wizard/services.js